import dedent from 'dedent';
import * as v from 'valibot';
import { z } from 'zod';
import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceBoolean, coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import form from '~/components/valibot/form';

export enum BreAerialType {
  FIVE = 'five',
  TWILIGHT = 'twilight',
  TEN = 'ten',
  VIDEO = 'video',
  COMBO = 'combo',
}

export function bre_is_aerial_photo(type?: BreAerialType): boolean {
  return Boolean(type && type !== BreAerialType.VIDEO);
}

export function bre_is_aerial_video(type?: BreAerialType): boolean {
  return Boolean(type && [BreAerialType.VIDEO, BreAerialType.COMBO].includes(type));
}

export default createPerformableConfig(
  'aerial',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      type: z.nativeEnum(BreAerialType),
      poi: z
        .array(
          z.object({
            name: z.string({ required_error: 'Point of Interest name is required' }),
            location: z.string({ required_error: 'Point of Interest location is required' }),
          }),
        )
        .optional(),
      self_edited: coerceBoolean().optional(),
      ai_edit: coerceBoolean().optional(),
      editing_credits: z.coerce.number().optional(),
    }),
  },
  {
    name: 'Aerial Photo & Video',
    group: 'Listing',
    tenant: TenantId.BEYOND_RE_MARKETING,
    thumbnail: 'tenant/bre/aerial/thumbnail.jpg',
    images: [],
    short: dedent`
      Showcase your property from every angle — day or night. Our aerial photo and video services \
      capture stunning views that highlight your property’s best features from above. \
      We offer high-resolution aerial photography, cinematic video flyovers, and breathtaking aerial \
      twilight shots — perfect for creating a dramatic and eye-catching first impression.
    `,
    submit: v.object({
      self_edited: form.boolean,
      ai_edit: form.boolean,
      editing_credits: v.optional(v.pipe(form.number(), v.minValue(0, 'Editing credits must be 0 or greater'))),
    }),
  },
);
